import React from "react";
import ServicesCard from "./ServicesCard";
import Section from "@/Components/LayoutComponents/Section";
import { toWebp } from "@/utils/common";

interface ServicesProps {
  data?: any;
  isMobile?: boolean;
}

const Services: React.FC< ServicesProps> = ({ data, isMobile  }) =>  {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  const servicesData =
    data?.cardsServices?.map((card: any) => ({
      title: card.title || "",
      details: card.description || "",
      link: card.link?.[0]?.href,
      label: card.link?.[0]?.label,
      image: card.image
        ? toWebp(`${baseUrl}${card.image.data.attributes.url}`)
        : "/images/ServicesInner/AI-Consulting.png",
      imageHover: card.hover_image
        ? toWebp(`${baseUrl}${card.hover_image?.data?.attributes?.url}`)
        : "/images/ServicesInner/AI-Consulting.png",
    })) || [];

  
  const sectionTitle = data?.title || "AI Services";

  return (
    <Section>
      <div className="container">
        <div>
          <h2 className="text-heading-1 font-bold text-primary-text text-center">
            {sectionTitle}
          </h2>
        </div>
        <div className="flex flex-col xl:gap-10 lg:gap-5 gap-10 mt-10">
          {servicesData.map((card: any, index: number) => (
            <ServicesCard
              key={index}
              number={String(index + 1).padStart(2, "0")}
              reverse={index % 2 === 1}
              {...card}
              isMobile={isMobile}
            />
          ))}
        </div>
      </div>
    </Section>
  );
};
export default Services;